import { useEffect, useState } from 'react';
import { toolbarIcons } from '../TipTapBarMenu/TipTapToolbar.tsx';
import { getParentNodeType } from '../helpers/textStyleHelpers.ts';

export const useIconsActiveFormats = (editor, textDefaultStyles) => {
  const [activeFormats, setActiveFormats] = useState({});

  useEffect(() => {
    if (!editor) return;

    const updateActiveFormats = () => {
      const parent = editor.state.selection.$from.parent;
      const parentNodeType = getParentNodeType(parent);

      const getStyleValue = (attribute) => textDefaultStyles[parentNodeType]?.[attribute];

      const newFormats = toolbarIcons.reduce((acc, { name, attribute, valueDefault }) => {
        if (!attribute) return acc;

        const isCustomActive = editor.isActive(name);
        const isDefaultActive = editor.isActive(valueDefault);
        const styleValue = getStyleValue(attribute);
        const matchesDefault = styleValue === valueDefault;

        acc[name] = isDefaultActive ? isDefaultActive : !isCustomActive && matchesDefault;
        return acc;
      }, {});

      setActiveFormats(newFormats);
    };

    editor.on('selectionUpdate', updateActiveFormats);
    editor.on('transaction', updateActiveFormats);

    return () => {
      editor.off('selectionUpdate', updateActiveFormats);
      editor.off('transaction', updateActiveFormats);
    };
  }, [editor, textDefaultStyles]);

  return activeFormats;
};
